var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vh-100 d-flex justify-content-center align-items-center"},[_c('lottie-vue-player',{staticStyle:{"width":"100%","height":"400px"},attrs:{"src":_vm.loading.data,"player-size":_vm.loading.options.size,"player-controls":_vm.loading.options.controls,"loop":_vm.loading.options.loop,"autoplay":_vm.loading.options.autoplay}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }